import React, { createContext, useContext, useState, useEffect } from 'react';
import { resolvePath } from '../lib/localizedPaths';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('cop31_language') || 'en';
  });

  useEffect(() => {
    localStorage.setItem('cop31_language', language);
    // Keep <html lang> attribute in sync for screen readers & browser hints
    document.documentElement.lang = language;
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'tr' : 'en');
  };

  const t = (en, tr) => {
    return language === 'en' ? en : tr;
  };

  // Returns the current-language version of a known route key
  // (register | blueZone | greenZone | supplierRegister | contractorRegister | login | home)
  const localizedPath = (key) => resolvePath(language, key);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t, localizedPath }}>
      {children}
    </LanguageContext.Provider>
  );
};
